import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { useEffect, useState } from 'react';
/**
 * React hook for fetching data from an API. Abstracts and exposes
 * the loading and error states of the API call.
 * @param {any} initialValue the initial value of the returned value
 * @param {function} apiFunction the function to call to fetch data
 * @returns {[any, boolean, any]} any array of the value, loading
 * state, and error state
 */

var useApiFetch = function useApiFetch(initialValue, apiFunction) {
  var _useState = useState(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = useState(false),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var _useState3 = useState(null),
      error = _useState3[0],
      setError = _useState3[1];

  var fetchValue =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _value;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoaded(false);
              _context.prev = 1;
              _context.next = 4;
              return apiFunction();

            case 4:
              _value = _context.sent;
              setValue(_value);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              setError(_context.t0);

            case 11:
              setLoaded(true);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function fetchValue() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    fetchValue();
  }, []);
  return [value, loaded, error];
};

export default useApiFetch;